<div
    class="trustpilot-widget"
    data-locale="da-DK"
    data-template-id="5419b637fa0340045cd0c936"
    data-businessunit-id="46d5231e000064000500cae3"
    data-style-height="20px"
    data-style-width="100%"
    data-theme="light"
>
    <a href="https://dk.trustpilot.com/review/www.kop-kande.dk" target="_blank" rel="noopener">Trustpilot</a>
</div>
